"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var PropertyNotDefinedError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(PropertyNotDefinedError, _Error);

  function PropertyNotDefinedError() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PropertyNotDefinedError);

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PropertyNotDefinedError)).call.apply(_getPrototypeOf2, [this].concat(params)));
    _this.name = 'PropertyNotDefinedError';
    return _this;
  }

  return PropertyNotDefinedError;
}((0, _wrapNativeSuper2.default)(Error));

exports.default = PropertyNotDefinedError;